// extracted by mini-css-extract-plugin
module.exports = {"container":"storyblokImage_container__QaIIf"};